export default {
    APP_ID: process.env.REACT_APP_ID,
    API_URL: window.globalConfig.adminApi,
    SSO_URL: window.globalConfig.ssoBack,
    LOGIN_URL: window.globalConfig.identityApi,
    PATH_FILE_UPLOAD: process.env.REACT_APP_PATH_FILE_UPLOAD,
    IMAGE_HEADER: "data:image/jpeg;base64,",
    REGEX_EMAIL: /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i,
    REGEX_CURRENCY: /(\d)(?=(\d{3})+(?!\d))/g,
    SECRET_KEY: "FWReactJSSecretKey",
    FORMAT_DAY: "YYYY-MM-DD",
    GLOBAL_FORMAT_DAY: "YYYY-MM-DD 00:00:00",
    DATE_AND_TIME: "DD-MM-YYYY HH:mm:ss",
    HOUR_FORMAT: "HH:mm:ss",
    FORMAT_DATE: "DD/MM/YYYY",
    NO_VALUE: null,
    MAX_SIZE_IMAGE: 450,
    MAX_SIZE_UPLOAD: 5, //unit Mb
    NO_VALUE_ID: 0,
    SUFFIX_TITLE: '.title',
    REGEX_TEXT: /[^0-9a-zA-Z\s]/gi,
    STORAGE_KEY: {
        PERMISSION: "_p",
        TOKEN_LOGGED: "TOKEN_LOGGED",
        MENU: "MENU",
        USER_DATA: "user_data",
        SESSION_ID: "sessionId",
        SESSION_EXPIRED: "SESSION_EXPIRED",
        ADMIN_USER: "ADMIN_USER"
    },
    TABLE: {
        SIZE_PER_PAGE: 10,
        SIZE_PER_PAGE_LIST: [
            {text: "5", value: 5},
            {text: "10", value: 10},
            {text: "20", value: 20},
            {text: "50", value: 50},
            {text: "100", value: 100}
        ]
    },
    STATUS: {
        INACTIVE: "INACTIVE",
        ACTIVE: "ACTIVE",
        PENDING: "PENDING",
        BUSY: "BUSY",
        REPAIR: "REPAIR",
        UNAVAILABLE: "UNAVAILABLE",
        ASSIGN: "ASSIGN",
        WATTING: "UNAVAWATTINGILABLE"
    },
    ACTION: {
        VIEW: "VIEW",
        UPDATE: "UPDATE",
        INSERT: "INSERT",
        DELETE: "DELETE",
        COPY: "COPY",
        PLAY: "PLAY",
        STOP: "STOP",
        CONFIRM: "CONFIRM",
        SEARCH: "SEARCH",
        RESET: "RESET"
    },
    RESPONSE_CODE: {
        SUCCESS: "",
        ERROR: "ERROR",
        EXCEPTION: "EXCEPTION",
    },
    STATUS_DEVICES: ["DOWN", "UP", "STARTED", "STOPPED"],
    STATUS_DEVICES_COLOR: ["INACTIVE", "ACTIVE", "WATTING", "INACTIVE"],
    RESPONSE_STATUS: {
        SUCCESS: "SUCCESS",
        ERROR: "ERROR",
        ERROR_WITH_PAR: "ERROR_WITH_PAR",
        API_000: "API-000",
        API000 : "API000"
    },
    SOCKET_TYPE: {
        USER_JOINED: "USER_JOINED",
        TEXT_MESSAGE: "TEXT_MESSAGE",
        USER_LEFT: "USER_LEFT",
        USER_JOINED_ACK: "USER_JOINED_ACK",
        CHANGE_BOOKING: "CHANGE_BOOKING",
        CHANGE_TICKET: "CHANGE_TICKET"
    },
    FILE_UPLOAD: {
        // VIDEO: [".mjpeg", ".mpg", ".mp4", ".m4a", ".m4v", ".mp4v", ".h263", ".h264", ".mkv", ".avi"],
        VIDEO: [".mp4"],
        AUDIO: [".mp3", ".wav"],
        IMAGE: [".jpeg", ".jpg", ".png", ".gif", ".bmp"]
    },
    SCROLL_TYPE: {
        SCROLL: 'scroll',
        TEXT: 'text',
        PAGE_SOURCE: 'pageSource'
    },
    TYPE_FILE: [
        "mjpeg", "mpg", "mp4", "m4a", "m4v", "mp4v", "h263", "h264", "mkv", "avi",
        "mp3", "wav", "jpeg", "jpg", "png", "gif", "bmp"
    ],
    FILE_DATA: [
        "application/octet-stream", "video/mpeg", "video/mp4", "video/m4a", "video/m4v", "video/mp4v",
        "video/h263", "video/h264", "video/x-matroska", "video/avi", "audio/mp3", "audio/wav", "image/jpeg",
        "image/jpeg", "image/png", "image/gif", "image/bmp"
    ],
    FEATURE: {
        TRAIN: {
            RE_CHECK: 5000
        }
    },
    FILE_SIZE: 10,
    COMPANY_TYPE: "CENTER_CODE"
}
